import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const apiKey = authService.getApiKey();

  // Only add Authorization header if API key exists and it's not the auth/authorize endpoint
  if (apiKey && !req.url.includes('/auth/authorize')) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${apiKey}`
      }
    });
    return next(authReq);
  }

  return next(req);
};